import {HTTP} from '@/CallAPI'

export default {
  getListLibrary () {
    return HTTP.get('media')
  },
  destroy (id) {
    return HTTP.delete('media/' + id)
  },
  getListTrash () {
    return HTTP.get('media/trash')
  },
  restore (id) {
    return HTTP.post('media/trash/' + id)
  },
  destroyPermanently (id) {
    return HTTP.delete('media/trash/' + id)
  },
  getLibraryDoc () {
    return HTTP.get('libraries/document')
  }
}



// WEBPACK FOOTER //
// ./src/service/library.js